import React ,{ useState , useEffect } from 'react';
import "./post.css"
import Layout from "../../component/layout/layout";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {ENV} from "../../services/env";
import Api from "../../services/api";
import {toast} from "react-toastify";
import queryString from "query-string";
import Loading from "../../component/loading/loading";
const Post = () => {
    useEffect(() => {
        getData()
        window.scrollTo({top:0 , behavior:"smooth"})
    } ,[])

    const [list , setList] = useState([])
    const [loading, setLoading] = useState(false)
    const history = useHistory()
    const getData = () => {
        setLoading(true)
        new Api().get(`${history.location.pathname}`)
            .then((res) => {
                setLoading(false)
                setList(res)
                window.scrollTo({top:0 , behavior:"smooth"})
            })
            .catch((err) => {
                setLoading(false)
                toast.error(err)
            })
    }
    return (
        <Layout>
            <div className={"container"}>
                <div className={"post"}>
                    {
                        loading ? <Loading /> :
                            <div className={"post-content"}>
                                <div  className={"post-title"}>
                                    <h2> {list.title}</h2>
                                </div>
                                {
                                    ( !history.location.pathname.includes("experience") && list.image || list.file )&&
                                <div className={"post-content-img"}>
                                    {
                                        list.type === "video" ?
                                            <video loop muted playsInline preload="auto" controls>
                                                <source src={ENV.API.IMG + list.file + "#t=0.005"}/>
                                            </video>
                                            :
                                            <>
                                                {(list.image || list.file) &&
                                                <img src={ENV.API.IMG + (list.image || list.file)}/>}
                                            </>

                                    }

                                </div>
                                }
                                {
                                    !history.location.pathname.includes("experience") &&
                                    <a className={"download"} href={ENV.API.IMG + (list.image || list.file)} download>
                                        دانلود
                                    </a>
                                }

                                <div dangerouslySetInnerHTML={{__html:list.description}} className={"gallery-des"}/>
                            </div>
                    }
                </div>
            </div>
        </Layout>

    );
};

export default Post;